import axios from 'src/utils/axios';

export const getMaterialImage = materialCode => {
    const config = {
        responseType: 'blob',
        headers: { 'Content-Type': 'application/json' }
      };
    return axios.get(`MaterialFile/${materialCode}`, config);
};


export const getMaterial = search => {
  return axios.get('/GetMaterials/' + search.toString().toLocaleLowerCase('tr-TR'));
}

